import styled from '@emotion/styled'
import { breakpoint, calcRem, fonts, metrics } from '../../__styling'
import { tokens } from '@news-mono/design-tokens'

// TheNightly Colors
const tnColors = tokens.thenightly.colors
const tnPalette = tnColors.palette
// TheNightly Metrics
const tnMetrics = metrics.thenightly
const tnMargins = tnMetrics.margins

export const StyledBanner = styled('div')(({ theme }) => ({
    fontFamily: fonts.thenightly.sansSerif,
    background: tnPalette.neutral[100],
    p: {
        color: tnPalette.white,
        margin: '0 auto',
        padding: calcRem(tnMargins.md, tnMargins.m2l),
        fontWeight: 600,
        lineHeight: '150%',
        maxWidth: theme.siteMetrics.mainContentWidth,
    },
    a: {
        textUnderlinePosition: 'under',
    },

    [breakpoint('sm')]: {
        a: {
            display: 'inline-block',
        },
    },

    [breakpoint('lg')]: {
        p: { padding: calcRem(tnMargins.md, 0) },
    },
}))
